import { render, staticRenderFns } from "./ResearchOutputClaimEscalation.vue?vue&type=template&id=553c9b94&scoped=true&"
import script from "./ResearchOutputClaimEscalation.vue?vue&type=script&lang=js&"
export * from "./ResearchOutputClaimEscalation.vue?vue&type=script&lang=js&"
import style0 from "./ResearchOutputClaimEscalation.vue?vue&type=style&index=0&id=553c9b94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c9b94",
  null
  
)

export default component.exports